import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "list__item" };
const _hoisted_2 = { class: "line line--aic line--nowrap" };
const _hoisted_3 = { class: "line__item line__item--grow" };
const _hoisted_4 = ["href"];
const _hoisted_5 = { class: "prod-line__cover" };
const _hoisted_6 = { class: "prod-line__main" };
const _hoisted_7 = { class: "prod-line__info" };
const _hoisted_8 = { class: "prod-line__brand" };
const _hoisted_9 = { class: "prod-line__name" };
const _hoisted_10 = { class: "prod-line__offer" };
const _hoisted_11 = { class: "line__item" };
const _hoisted_12 = { class: "form-group" };
import Picture from "../../../../components/Picture.vue";
import { computed, ref, watch } from "vue";
import Checkbox from "../../../../components/Checkbox.vue";
import CartEventBus from "../../CartEventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChooseGiftItem',
    props: {
        gift: { type: Object, required: true },
        gifts: { type: Object, required: true },
        giftsLeft: { type: Number, required: true },
    },
    setup(__props) {
        const props = __props;
        const active = computed(() => !!props.gifts.find(item => item.productId === props.gift.productId));
        const disabled = computed(() => !active.value && (props.giftsLeft === 0));
        const checked = ref(active.value);
        watch(active, value => checked.value = value);
        function onchange(event) {
            select(event.target.checked);
        }
        function select(checked) {
            if (disabled.value) {
                return;
            }
            if (active.value && !checked) {
                CartEventBus.emit('gifts:remove', props.gift.productId);
            }
            else if (checked) {
                CartEventBus.emit('gifts:add', props.gift.productId);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("a", {
                            href: __props.gift.url,
                            class: "prod-line prod-line--extra"
                        }, [
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(Picture, {
                                    picture: __props.gift.image
                                }, null, 8 /* PROPS */, ["picture"])
                            ]),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, _toDisplayString(__props.gift.brandName), 1 /* TEXT */),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_9, _toDisplayString(__props.gift.name) + ",", 1 /* TEXT */),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(__props.gift.offerName), 1 /* TEXT */)
                                ])
                            ])
                        ], 8 /* PROPS */, _hoisted_4)
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(Checkbox, {
                                modelValue: checked.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((checked).value = $event)),
                                disabled: disabled.value,
                                onChange: onchange
                            }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                        ])
                    ])
                ])
            ]));
        };
    }
});
